import { render } from "./ProveedoresList.vue?vue&type=template&id=101d1160&scoped=true"
import script from "./ProveedoresList.vue?vue&type=script&lang=js"
export * from "./ProveedoresList.vue?vue&type=script&lang=js"

import "./ProveedoresList.vue?vue&type=style&index=0&id=101d1160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101d1160"]])

export default __exports__